import { EcgAPI } from './types'

export const ecgApi: EcgAPI = ky => {
  return {
    async fetch({ patientId }) {
      return ky(`patient/${patientId}/ecg/`, {
        method: 'get'
      }).json()
    },
    async save({ patientId, measureDatetime, heartWave, heartRate }) {
      console.log({
        measureDatetime: measureDatetime.toISOString(),
        heartWave: heartWave.join(','),
        heartRates: [
          {
            measureDatetime: measureDatetime.toISOString(),
            heartRate: heartRate.toFixed()
          }
        ]
      })
      return ky(`patient/${patientId}/ecg/`, {
        method: 'post',
        json: {
          measureDatetime: measureDatetime.toISOString(),
          heartWave: heartWave.join(','),
          heartRates: [
            {
              measureDatetime: measureDatetime.toISOString(),
              heartRate: heartRate.toFixed()
            }
          ]
        }
      }).json()
    },
    async fetchSetting({ patientId }) {
      return ky(`patient/${patientId}/ecg_setting/`, {
        method: 'get'
      }).json()
    },
    async saveSetting({ patientId, setting }) {
      return ky(`patient/${patientId}/ecg_setting/`, {
        method: 'put',
        json: setting
      }).json()
    }
  }
}
